import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { PageHeaderSection } from "../../components/common/PageHeadSection";
import { Button, Col, Flex, Form, Input, Row } from "antd";
import _ from "lodash";
import { mdlStopFreeSaleReportOptionRequest } from "../../models/service-models/stop-free-sale/StopFreeSaleReportOptionRequest";
import { StopFreeSaleService } from "../../services/StopFreeSaleService";
import { mdlReportOptionType } from "../../models/enums/ReportOptionType";
import { mdlStopFreeSaleReportRequest } from "../../models/service-models/stop-free-sale/StopFreeSaleReportRequest";
import { HotelSelect } from "../../components/common/HotelSelect";
import { StopFreeSaleReportOptionsSelect } from "../../components/common/StopFreeSaleReportOptionsSelect";
import { mdlIdCodeNamePair } from "../../models/domain/IdCodeNamePair";
import { StopFreeSaleReportTypeSelect } from "../../components/stop-free-sale/StopFreeSaleReportTypeSelect";
import { enmStopFreeSaleReportTypes } from "../../models/enums/StopFreeSaleReportTypes";
import { StopFreeSaleReportStatusSelect } from "../../components/stop-free-sale/StopFreeSaleReportStatusSelect";
import { enmStopFreeSaleStatus } from "../../models/enums/StopFreeSaleStatus";
import { MonthSelect } from "../../components/common/MonthSelect";
import { StopFreeSaleReportTable } from "../../components/stop-free-sale/StopFreeSaleReportTable";
import { mdlStopFreeSaleReportOptionData } from "../../models/service-models/stop-free-sale/StopFreeSaleReportOptionData";
import dayjs from "dayjs";
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { mdlStopFreeSaleReport } from "../../models/domain/StopFreeSaleReport";
import StopSaleReport from "../../components/stop-free-sale/StopFreeSaleReportTableNew";
import { useAppDispatch } from "../../store/Hooks";

export const StopFreeSaleReport = () => {
    const [startDate, setStartDate] = useState<Date>();
    const [endDate, setEndDate] = useState<Date>();
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [selectedHotel, setSelectedHotel] = useState<string>();
    const [selectedHotels, setSelectedHotels] = useState<string[]>();
    const [markets, setMarkets] = useState<mdlIdCodeNamePair[]>();
    const [agencies, setAgencies] = useState<mdlIdCodeNamePair[]>();
    const [rooms, setRooms] = useState<mdlIdCodeNamePair[]>();
    const [roomTypes, setRoomTypes] = useState<mdlIdCodeNamePair[]>();
    const [boards, setBoards] = useState<mdlIdCodeNamePair[]>();
    const [formValues, setFormValues] = useState<any>();
    const [activeMonth, setActiveMonth] = useState<number>();
    const [activeYear, setActiveYear] = useState<number>();
    const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>();
    const [reportTypes, setReportTypes] = useState<enmStopFreeSaleReportTypes[]>();
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (selectedHotels) {
            setMutateData(mdlReportOptionType.Markets, (data: mdlStopFreeSaleReportOptionData) => {
                setMarkets(data.hotelMarkets);
                form.setFieldsValue({ markets: data.hotelMarkets?.map((x: mdlIdCodeNamePair) => x.id) });
                
                setAgencies(data.hotelAgencies);
                form.setFieldsValue({ agencies: data.hotelAgencies?.map((x: mdlIdCodeNamePair) => x.id) });
                
                setRooms(data.hotelRooms);
                form.setFieldsValue({ rooms: data.hotelRooms?.map((x: mdlIdCodeNamePair) => x.id) });
            
                setRoomTypes(data.hotelRoomTypes);
                form.setFieldsValue({ roomTypes: data.hotelRoomTypes?.map((x: mdlIdCodeNamePair) => x.id) });
           
                setBoards(data.hotelBoards);
                form.setFieldsValue({ boards: data.hotelBoards?.map((x: mdlIdCodeNamePair) => x.id) });
            });
        }
        if (!selectedHotels) {
            form.setFieldsValue({ stopFreeSaleStatus: 1 });
            form.setFieldsValue({ month: 3 })
        }
    if(!activeMonth){
        const currentDate = dayjs();
        form.setFieldsValue({ activeMonth: currentDate.format("MM") })
        form.setFieldsValue({ activeYear: currentDate.format("YYYY") })
        handleActiveDay(parseInt(currentDate.format("MM")),parseInt(currentDate.format('YYYY')));
      }
    }, [selectedHotels]);

    //#region API CALLS
    const getReportOptions = useMutation({
        mutationFn: (optionType: mdlReportOptionType) => {
            return StopFreeSaleService.GetReportOptions({ hotelIds: selectedHotels, optionType: optionType, type: "All" } as mdlStopFreeSaleReportOptionRequest)
        }
    })

    const setMutateData = async (optionType: mdlReportOptionType, fnSuccess: Function) => {
        if (selectedHotels?.length == 0) {
            fnSuccess([]);
            return;
        }
        const data = await getReportOptions.mutateAsync(optionType)
        if (data && data.body && data.body && data.body.data) {
            fnSuccess(data.body.data);
        }
    }
    const hotelSelectChange = (value: string[]) => {
        setSelectedHotels(value);
        form.setFieldsValue({ hotelIds: value });
    }
    const handleTableParamsChange = (filters: any) => { }
    
    const onRowSelect = (indexes: number[]) => {
        setSelectedRowKeys(indexes);
    }


    
    const handleActiveDay = (month:number,year:number) => {
        setSelectedRowKeys([]);
        setActiveMonth(month);
        setActiveYear(year);
     }
    const handleTableData = (values: any) => {
        setFormValues(values);
    }
    
    const handleReportTypeChange = (values: string | string[] | enmStopFreeSaleReportTypes[]) => {
        setReportTypes(values as enmStopFreeSaleReportTypes[])
    }
    //#endregion

    //#region Export Excel

    const getColumnLetter = (colIndex: number): string => {
        let letter = "";
        while (colIndex > 0) {
            const remainder = (colIndex - 1) % 26;
            letter = String.fromCharCode(65 + remainder) + letter;
            colIndex = Math.floor((colIndex - 1) / 26);
        }
        return letter;
    };
  
    const getDetailRequest = (id : string,startDate:Date, endDate:Date) => {
        return  { 
           hotelId: id, 
           agencies: form.getFieldValue("agencies"),
           markets: form.getFieldValue("markets"),
           rooms: form.getFieldValue("rooms"),
           roomTypes: form.getFieldValue("roomTypes"),
           boards: form.getFieldValue("boards"),
           stopFreeSaleReportTypes: reportTypes,
           stopFreeSaleEndDate: endDate,
           stopFreeSaleStartDate: startDate,
           stopFreeSaleStatus: formValues.stopFreeSaleStatus} as mdlStopFreeSaleReportRequest
    }
    
      const getDaysInMonth = (month: number, year: number) => {
        const days = [];
        const date = dayjs(`${year}-${month}-01`);
        const daysInMonth = date.daysInMonth(); 
        for (let i = 1; i <= daysInMonth; i++) {
          const currentDay = date.date(i);
          days.push({
            day: currentDay.format('DD'),    
            date: currentDay.format('YYYY-MM-DD'),   
            dayName: currentDay.format('ddd'),        
          });
        }
        return days;
      };
      let rowCounter = 1; 
      const addHeaderRows = (worksheet: ExcelJS.Worksheet, columnCount: number,startDate:Date, endDate:Date,hotelName:string) => {
        const currentRow = worksheet.rowCount + 1; 
    
        const lastColumn = getColumnLetter(columnCount);
    
        const firstRow = worksheet.addRow([]);
        worksheet.mergeCells(`A${currentRow}:${lastColumn}${currentRow}`);
        firstRow.getCell(1).value = dayjs(startDate).format("MMMM - YYYY");
        firstRow.getCell(1).alignment = { horizontal: "center", vertical: "middle" };
    
        const secondRow = worksheet.addRow([]);
        worksheet.mergeCells(`A${currentRow + 1}:${lastColumn}${currentRow + 1}`);
        secondRow.getCell(1).value = hotelName;
        secondRow.getCell(1).alignment = { horizontal: "center", vertical: "middle" };
    
        firstRow.height = 20;
        secondRow.height = 20;
    
        return currentRow + 2;  
    };
    const handleExport = async () => {
        if (!data || !data.body || !data.body.data || !startDate || !reportTypes || !activeMonth || !activeYear) return;

        
        try {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Report");
            let currentRow = 0;

            const fetchData = async (report: mdlStopFreeSaleReport) => {
                if (!startDate || !endDate) return;
                const _startDate = dayjs(startDate).add((report?.monthIndex ?? 0), 'month').toDate();
                const _endDate = dayjs(endDate).add((report?.monthIndex ?? 0), 'month').toDate();

                // Her otel için sıralı şekilde veri ekle
                for (const hotel of report.hotelData ?? []) {
                    const request = getDetailRequest(hotel.hotelId, _startDate, _endDate);
                    const response = await StopFreeSaleService.GetReportDetail(request);
                    
                    if (response.body && response.body.data) {
                        const days = getDaysInMonth(parseInt(dayjs(_startDate).format("MM")), parseInt(dayjs(endDate).format("YYYY")))
                            .map((x: any) => dayjs(x.date).format("YYYY-MM-DD"));
                        
                        let header: any[] = [];
                        reportTypes.forEach((reportType) => {
                            switch (reportType) {
                                case enmStopFreeSaleReportTypes.Agency:
                                    header.push("Agency");
                                    break;
                                case enmStopFreeSaleReportTypes.Market:
                                    header.push("Market");
                                    break;
                                case enmStopFreeSaleReportTypes.RoomType:
                                    header.push("Room Type");
                                    break;
                                case enmStopFreeSaleReportTypes.Rooms:
                                    header.push("Room");
                                    break;
                                case enmStopFreeSaleReportTypes.Board:
                                    header.push("Board");
                                    break;
                            }
                        });

                        // Boş satır ekle
                        if (currentRow > 0) {
                            worksheet.addRow([]);
                            currentRow++;
                        }

                        currentRow = addHeaderRows(worksheet, (reportTypes.length + days.length), _startDate, _endDate, hotel.hotelName);
                        
                        const rows = createExcelJSData(
                            response.body.data ?? [],
                            reportTypes,
                            days,
                            header
                        );
                        
                        worksheet.addRows(rows);
                        styleWorksheet(worksheet, rows, reportTypes, header, currentRow);
                        currentRow += rows.length;
                    }
                }
            };

            const fetchReports = (data.body.data as any).result?.map((report: mdlStopFreeSaleReport, monthIndex: number) => 
                fetchData({...report, monthIndex: monthIndex})
            );

            await Promise.all(fetchReports);

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: "application/octet-stream" });
            saveAs(blob, "report.xlsx");
        } catch (error) {
            console.error('Export error:', error);
        } finally {
        }
    };
    
    const removeEmptyRows = (worksheet: ExcelJS.Worksheet) => {
        for (let i = worksheet.rowCount; i >= 1; i--) {
            const row = worksheet.getRow(i);
            
            if (!Array.isArray(row.values)) continue;
            
            const isEmpty = row.values.slice(1).every((cell: any) => {
                return cell === null || cell === undefined || cell === '';
            });
            
            if (isEmpty) {
                worksheet.spliceRows(i, 1);
            }
        }
    };
    
    const createExcelJSData = (
        reportData: mdlStopFreeSaleReport[],
        reportTypes: enmStopFreeSaleReportTypes[],
        days: string[],
        header: any[]
    ) => {
        const header1 = _.cloneDeep(header);
        const header2 = _.cloneDeep(header).map( x=> "");
        days.forEach((day) => header1.push(dayjs(day).format("ddd")));
        days.forEach((day) => header2.push(dayjs(day).format("DD")));
    
        const rows = [header1,header2];
    
        reportData.forEach((row) => {
            const dataRow: any[] = [];
            reportTypes.forEach((reportType) => {
                switch (reportType) {
                    case enmStopFreeSaleReportTypes.Agency:
                        dataRow.push(row.agencyName ?? "");
                        break;
                    case enmStopFreeSaleReportTypes.Agency:
                        dataRow.push(row.agencyName ?? "");
                        break;
                    case enmStopFreeSaleReportTypes.Market:
                        dataRow.push(row.marketName ?? "");
                        break;
                    case enmStopFreeSaleReportTypes.RoomType:
                        dataRow.push(row.roomTypeName ?? "");
                        break;
                    case enmStopFreeSaleReportTypes.Rooms:
                        dataRow.push(row.roomName ?? "");
                        break;
                    case enmStopFreeSaleReportTypes.Board:
                        dataRow.push(row.boardName ?? "");
                        break;
                }
            });
    
            days.forEach((day, index) => {
                const dayStatus = row.dayStatus?.[index];
                dataRow.push(dayStatus.status != 'none' ? `${new Date(dayStatus.sendDate).toLocaleString('tr-TR', {month: '2-digit'})}.${new Date(dayStatus.sendDate).getDate()}   ` + dayStatus.status : "");
            });
    
            rows.push(dataRow);
        });
    
        return rows;
    };
    
    const styleWorksheet = (
        worksheet: ExcelJS.Worksheet,
        rows: any[],
        reportTypes: enmStopFreeSaleReportTypes[],
        header: any[],
        totalRowCount: number
    ) => {
        const stopSaleStyle = {
            size: 12, 
            color: { argb: 'FFF' },
            type: "pattern" as any,
            pattern: "solid" as any,
            fgColor: { argb: "FFFF0000" as any }
        };
    
        const freeSaleStyle = {
            size: 12, 
            color: { argb: 'FFF' },
            type: "pattern" as any,
            pattern: "solid" as any,
            fgColor: { argb: "FF00FF00" as any }
        };

        const whiteFontStyle = { color: { argb: "000000" } };
        const headerWidth = header.map( x=> ({ width:20}));
        worksheet.columns = [
            ...headerWidth,
            ...Array(rows[0].length - 1).fill({ width: 5 }),
        ];
        
        worksheet.eachRow((row, rowIndex) => {
            row.eachCell((cell, colIndex) => {
                if (cell.text && cell.text.includes("stopsale")) {
                    cell.fill = stopSaleStyle;
                    cell.font = whiteFontStyle;
                }else if (cell.text && cell.text.includes("freesale")) {
                    cell.font = whiteFontStyle;
                    cell.fill = freeSaleStyle;
                }
            });
        });
    };
    //#endregion
    
      const {
        data,
        isLoading,
        isError,
        refetch
      } = useQuery(
        ["getReport", activeMonth, activeYear, formValues],
        () => {
          
            let _activeMonth = activeMonth?.toString().padStart(2,"0");
            let _activeYear = activeYear?.toString().padStart(4,"0");
            if (selectedHotels && activeMonth && activeYear) {
              _activeMonth = ("00").substring(activeMonth.toString().length, 2) + activeMonth.toString();
              _activeYear = ("0000").substring(activeYear.toString().length, 4) + activeYear.toString();
            }else if (formValues && formValues.activeDay){
              _activeMonth = formValues.activeMonth;
              _activeYear = formValues.activeMonth;
            }
    
            const startDate = dayjs(`02.${_activeMonth}.${_activeYear}`,"DD.MM.YYYY");
            const endDate =  dayjs(`02.${_activeMonth}.${_activeYear}`,"DD.MM.YYYY").add((formValues?.month ?? 0),"month");
            setStartDate(startDate.toDate());
            setEndDate(endDate.toDate());
            if(!(endDate.isValid()) || !(startDate.isValid()))
              return
            var request: mdlStopFreeSaleReportRequest = {
              stopFreeSaleEndDate: endDate.toDate(),
              stopFreeSaleStartDate: startDate.toDate(),
              hotelIds: selectedHotels,
              agencies: form.getFieldValue("agencies"),
              markets: form.getFieldValue("markets"),
              rooms: form.getFieldValue("rooms"),
              roomTypes: form.getFieldValue("roomTypes"),
              boards: form.getFieldValue("boards"),
              isActiveStopFreeSale: true,
              stopFreeSaleStatus: formValues.stopFreeSaleStatus,
            };
            return StopFreeSaleService.GetReport(request);
        },
        {
          refetchOnWindowFocus: false,
          enabled: !!activeMonth && activeMonth != null && formValues != undefined,
          onSuccess(data) {
            if(data){
              _.each((data.body?.data as any).result, function (d, i) {
                if(d){
                  d.key = i;
                  _.each(d.subItems, function (subItem, cIndex) {
                    subItem.key = cIndex;
                  })
                }
              })
            }
          },
        }
      );
    
    return (
        <>
            <div className="nk-content ">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <PageHeaderSection
                                pageTitle={t("stopFreeSale.report.title")}
                            />
                            <div className="nk-block">
                                <div className="card card-bordered h-100">
                                    <div className="card-inner">
                                        <Form
                                            form={form}
                                            name="board-form"
                                            layout="vertical"
                                            onFinish={async (values) => handleTableData(values)}
                                            autoComplete="off"
                                        >
                                            <Row gutter={16}>
                                                <Col span={6}>
                                                    <Form.Item<mdlStopFreeSaleReportRequest>
                                                        label={t("stopFreeSale.report.hotels")}
                                                        name="hotelIds"
                                                        rules={[{ required: true, message: t("common.required") }]}
                                                    >
                                                        <HotelSelect onChange={hotelSelectChange} mode="multiple" />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={6}>
                                                    <Form.Item<mdlStopFreeSaleReportRequest>
                                                        label={t("stopFreeSale.report.markets")}
                                                        name={['markets']}
                                                        rules={[{ required: true, message: t("common.required") }]}
                                                    >
                                                        <StopFreeSaleReportOptionsSelect
                                                            fnSelectAll={(value: string[]) => form.setFieldsValue({ markets: markets?.map(x => x.id) })}
                                                            fnClearAll={(value: string[]) => form.setFieldsValue({ markets: [] })}
                                                            id="markets"
                                                            data={markets}
                                                            onChange={(value: string[]) => { console.log(value); form.setFieldsValue({ markets: value }) }}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={6}>
                                                    <Form.Item<mdlStopFreeSaleReportRequest>
                                                        label={t("stopFreeSale.report.agencies")}
                                                        name="agencies"
                                                        rules={[{ required: true, message: t("common.required") }]}
                                                    >
                                                        <StopFreeSaleReportOptionsSelect
                                                            fnSelectAll={(value: string[]) => form.setFieldsValue({ agencies: agencies?.map(x => x.id) })}
                                                            fnClearAll={(value: string[]) => form.setFieldsValue({ agencies: [] })}
                                                            id="agencies"
                                                            data={agencies}
                                                            onChange={(value: string[]) => form.setFieldsValue({ agencies: value })}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={6}>
                                                    <Form.Item<mdlStopFreeSaleReportRequest>
                                                        label={t("stopFreeSale.report.roomTypes")}
                                                        name="roomTypes"
                                                        rules={[{ required: true, message: t("common.required") }]}
                                                    >
                                                        <StopFreeSaleReportOptionsSelect
                                                            fnSelectAll={(value: string[]) => form.setFieldsValue({ roomTypes: roomTypes?.map(x => x.id) })}
                                                            fnClearAll={(value: string[]) => form.setFieldsValue({ roomTypes: [] })}
                                                            onChange={(value: string[]) => form.setFieldsValue({ roomTypes: value })}
                                                            data={roomTypes}
                                                            id="roomTypes"
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={16}>
                                                <Col span={6}>
                                                    <Form.Item<mdlStopFreeSaleReportRequest>
                                                        label={t("stopFreeSale.report.rooms")}
                                                        name="rooms"
                                                        rules={[{ required: true, message: t("common.required") }]}
                                                    >
                                                        <StopFreeSaleReportOptionsSelect
                                                            fnSelectAll={(value: string[]) => form.setFieldsValue({ rooms: rooms?.map(x => x.id) })}
                                                            fnClearAll={(value: string[]) => form.setFieldsValue({ rooms: [] })}
                                                            onChange={(value: string[]) => form.setFieldsValue({ rooms: value })}
                                                            data={rooms}
                                                            id="rooms"
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={6}>
                                                    <Form.Item<mdlStopFreeSaleReportRequest>
                                                        label={t("stopFreeSale.report.boards")}
                                                        name="boards"
                                                        rules={[{ required: true, message: t("common.required") }]}
                                                    >
                                                        <StopFreeSaleReportOptionsSelect
                                                            fnSelectAll={(value: string[]) => form.setFieldsValue({ boards: boards?.map(x => x.id) })}
                                                            fnClearAll={(value: string[]) => form.setFieldsValue({ boards: [] })}
                                                            id="boards"
                                                            data={boards}
                                                            onChange={(value: string[]) => form.setFieldsValue({ boards: value })}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={6}>
                                                    <Form.Item<mdlStopFreeSaleReportRequest>
                                                        label={t("stopFreeSale.report.reportTypes")}
                                                        name="reportTypes"
                                                        rules={[{ required: true, message: t("common.required") }]}
                                                    >
                                                        <StopFreeSaleReportTypeSelect onChange={handleReportTypeChange} mode="multiple" specificTypes={[enmStopFreeSaleReportTypes.Agency, enmStopFreeSaleReportTypes.Market, enmStopFreeSaleReportTypes.Board, enmStopFreeSaleReportTypes.RoomType, enmStopFreeSaleReportTypes.Rooms]} />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={6}>
                                                    <Form.Item<mdlStopFreeSaleReportRequest>
                                                        label={t("stopFreeSale.report.release")}
                                                        name="release"
                                                        rules={[{ required: false, message: t("common.required") }]}
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={16}>
                                                <Col span={6}>
                                                    <Form.Item<mdlStopFreeSaleReportRequest>
                                                        label={t("stopFreeSale.report.stopFreeSaleStatus")}
                                                        name="stopFreeSaleStatus"
                                                        rules={[{ required: true, message: t("common.required") }]}
                                                    >
                                                        <StopFreeSaleReportStatusSelect specificTypes={[enmStopFreeSaleStatus.New, enmStopFreeSaleStatus.Cancel]} />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={6}>
                                                    <Form.Item<mdlStopFreeSaleReportRequest>
                                                        label={t("stopFreeSale.report.month")}
                                                        name="month"
                                                        rules={[{ required: true, message: t("common.required") }]}
                                                    >
                                                        <MonthSelect labelType="number" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Form.Item>
                                                <Flex align={"center"} justify="flex-end">
                                                    {
                                                        data?.body?.data &&
                                                        <Button className="btn btn-dark me-2" onClick={(handleExport)}>{t("common.exportToExcel")}</Button>
                                                    }
                                                    <Button type="primary" htmlType="submit">{t("common.save")}</Button>
                                                </Flex>
                                            </Form.Item>
                                        </Form>
                                    </div>
                                </div>
                            </div>

                            <StopFreeSaleReportTable
                                data={data?.body?.data}
                                isLoading={isLoading}
                                onRowSelection={onRowSelect}
                                selectedRowKeys={selectedRowKeys}
                                fnHandleActiveDay={handleActiveDay}
                                formValues={formValues}
                                hotelIds={selectedHotels}
                                agencies={form.getFieldValue("agencies")}
                                markets={form.getFieldValue("markets")}
                                rooms={form.getFieldValue("rooms")}
                                roomTypes={form.getFieldValue("roomTypes")}
                                boards={form.getFieldValue("boards")}
                                activeMonth={activeMonth}
                                reportTypes={reportTypes}
                                activeYear={activeYear}
                                pagination={undefined} />


                        </div>
                    </div>
                </div>
            </div>
        </>


    );
};
